import { createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, toDisplayString as _toDisplayString, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, resolveComponent as _resolveComponent, createVNode as _createVNode } from "vue"

const _hoisted_1 = {
  key: 0,
  class: "pl-4"
}
const _hoisted_2 = { class: "text-danger" }

export function render(_ctx, _cache) {
  const _component_v_img = _resolveComponent("v-img")

  return (_openBlock(), _createElementBlock("div", null, [
    _cache[1] || (_cache[1] = _createElementVNode("h3", { class: "pl-4" }, " Please be aware that new IFM Reporting is based on figures excluding weekends. This leads to shortened handling times. ", -1)),
    (_ctx.reportOutdated)
      ? (_openBlock(), _createElementBlock("div", _hoisted_1, [
          _cache[0] || (_cache[0] = _createElementVNode("h2", { class: "text-danger" }, [
            _createTextVNode(" Report is outdated. "),
            _createElementVNode("br")
          ], -1)),
          _createElementVNode("h3", _hoisted_2, "Report date: " + _toDisplayString(_ctx.reportDate), 1)
        ]))
      : _createCommentVNode("", true),
    _createVNode(_component_v_img, { src: "/api/v1.0/cases/reporting/ytd/image" })
  ]))
}